import React, {FC} from 'react';
import { Button, Form, Row, Col, Input, Select, Divider, Typography, FormInstance, Flex } from 'antd';

const { Option } = Select;

interface CustomerFormProps {
  customerForm: FormInstance;
  formDisabled: boolean;
  copyAddressCallback?: () => void
}

export const CustomerForm: FC<CustomerFormProps> = ({customerForm, formDisabled, copyAddressCallback}) => {
    return(
        <Form layout='vertical' form={customerForm} disabled={formDisabled}>

            <Row gutter={16} style={{paddingTop: 8}}>
              <Col span={4}>
                <Form.Item name="title" label="Title">
                  <Input placeholder="title" />
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item name="firstName" label="First name">
                  <Input placeholder="first name" />
                </Form.Item>
              </Col>
              <Col span={10}>
                <Form.Item name="lastName" label="Last name">
                  <Input placeholder="family name" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={16} style={{paddingTop: 16}}>
              <Col span={12}>
                <Form.Item name="email" label="Email" rules={[{required: true, message: 'Plese enter the customer email'}]}>
                  <Input placeholder="email" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item 
                  name={["preferences", "language"]} 
                  label="Preferred language" 
                  rules={[{ required: true, message: 'Please select the customer preferred language'}]}>
                  <Select placeholder="select the language preference">
                    <Option value="fr">fr</Option>
                    <Option value="en">en</Option>
                  </Select>
                </Form.Item>
              </Col>
            </Row>

            <Divider />

            <Typography.Title level={5} style={{ marginTop: 20 }}>Phone number</Typography.Title>
            <Row gutter={16}>
              <Col span={4}>
                <Form.Item name={["phone", "prefix"]} label="Prefix">
                    <Input />
                </Form.Item>
              </Col>
              <Col span={20}>
                <Form.Item name={["phone", "number"]} label="Number">
                    <Input />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Typography.Title level={5} style={{ marginTop: 20 }}>Shipping Address</Typography.Title>
                <Form.Item 
                name={["shippingAddress", "line1"]}
                rules={[{ required: true, message: 'Please enter the address first line'}]} 
                label="Line 1">
                    <Input />
                </Form.Item>
                <Form.Item name={["shippingAddress", "line2"]} label="Line 2" style={{paddingTop: 8}}>
                    <Input />
                </Form.Item>
                <Form.Item 
                name={["shippingAddress", "postalCode"]} 
                rules={[{ required: true, message: 'Please enter the postal code'}]}
                style={{paddingTop: 8}}
                label="Postal Code">
                    <Input />
                </Form.Item>
                <Form.Item 
                name={["shippingAddress", "city"]} 
                rules={[{ required: true, message: 'Please enter the city'}]}
                style={{paddingTop: 8}}
                label="City">
                    <Input />
                </Form.Item>
                <Form.Item name={["shippingAddress", "state"]} label="State/Province" style={{paddingTop: 8}}>
                    <Input />
                </Form.Item>
                <Form.Item 
                name={["shippingAddress", "country"]} 
                rules={[{ required: true, message: 'Please enter the country'}]}
                style={{paddingTop: 8}}
                label="Country">
                    <Input />
                </Form.Item>                
              </Col>

              <Col span={12}>
                <Typography.Title level={5} style={{ marginTop: 20 }}>Billing Address</Typography.Title>
                <Form.Item 
                  name={["billingAddress", "line1"]}
                  rules={[{ required: true, message: 'Please enter the address first line'}]}
                  label="Line 1">
                    <Input />
                </Form.Item>
                <Form.Item name={["billingAddress", "line2"]} label="Line 2" style={{paddingTop: 8}}>
                    <Input />
                </Form.Item>
                <Form.Item 
                name={["billingAddress", "postalCode"]}
                rules={[{ required: true, message: 'Please enter the postal code'}]}
                style={{paddingTop: 8}}
                label="Postal Code">
                    <Input />
                </Form.Item>
                <Form.Item 
                name={["billingAddress", "city"]}
                rules={[{ required: true, message: 'Please enter the city'}]}
                style={{paddingTop: 8}}
                label="City">
                    <Input />
                </Form.Item>
                <Form.Item name={["billingAddress", "state"]} label="State/Province" style={{paddingTop: 8}}>
                    <Input />
                </Form.Item>
                <Form.Item 
                name={["billingAddress", "country"]} 
                rules={[{ required: true, message: 'Please enter the country'}]}
                style={{paddingTop: 8}}
                label="Country">
                    <Input />
                </Form.Item>
                {copyAddressCallback && <Flex align='flex-start' justify='flex-end'>
                  <Button type="text" onClick={copyAddressCallback}>Copy from shipping address</Button>
                </Flex>
                }
              </Col>
            </Row>
          </Form>
    );
}
